import { create } from "zustand";

import type { ForbiddenApiErrorAccessibles } from "@/lib/api/error.forbidden";

export type ForbiddenApiErrorDialogProps = {
  accessibles: ForbiddenApiErrorAccessibles;
  /**
   * Go backボタン押下時のコールバック
   * - {@linkcode closeForbiddenErrorDialog}を渡すと、ボタン押下時にダイアログを閉じる
   */
  onGoBack: () => void;
};

type ForbiddenApiErrorDialogState = {
  /**
   * @note
   * `props`が`null`かどうかでダイアログの開閉を制御すると、ダイアログが閉じる際のアニメーション時に
   * タイトルやメッセージが消えてしまうため、isOpenで別途開閉状態を管理する
   */
  isOpen: boolean;
  props: ForbiddenApiErrorDialogProps | null;
  open: (props: ForbiddenApiErrorDialogProps) => void;
  close: () => void;
};

export const useForbiddenApiErrorDialog = create<ForbiddenApiErrorDialogState>(
  (set) => ({
    isOpen: false,
    props: null,
    open: (props) => set({ isOpen: true, props }),
    close: () => set((prev) => ({ ...prev, isOpen: false })),
  }),
);
